"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import MegaMenuHeader from "@/components/nav/MegaMenuHeader";
import MegaMenuItem from "@/components/nav/MegaMenuItem";
import MegaMenuLink from "@/components/nav/MegaMenuLink";
import { ratgeberTheme, type RatgeberColumn as RatgeberColumnData } from "@/lib/ratgeber";
import { cn } from "@/lib/utils";

/** Eine Inhalts-Spalte des Mega-Menüs: Header, Linkliste, farbiger Footer-Link. */
export default function MegaMenuColumn({
  column,
  onNavigate,
}: {
  column: RatgeberColumnData;
  onNavigate?: () => void;
}) {
  const theme = ratgeberTheme[column.color];

  return (
    <div className="flex flex-col min-w-0">
      <MegaMenuHeader
        icon={column.icon}
        color={column.color}
        title={column.title}
        description={column.description}
      />

      <ul className="flex flex-col mt-5">
        {column.links.map((link) => (
          <MegaMenuItem key={link.label}>
            <MegaMenuLink
              href={link.href}
              onNavigate={onNavigate}
              className={theme.linkHover}
            >
              {link.label}
            </MegaMenuLink>
          </MegaMenuItem>
        ))}
      </ul>

      <Link
        href={column.footer.href}
        onClick={onNavigate}
        className={cn(
          "group/footer mt-auto pt-6 inline-flex items-center gap-1.5 text-sm font-bold transition-colors duration-150",
          theme.footer
        )}
      >
        {column.footer.label}
        <ArrowRight
          size={15}
          className="group-hover/footer:translate-x-0.5 transition-transform"
          aria-hidden="true"
        />
      </Link>
    </div>
  );
}
